<template>
    <CardBase class="shadow cursor-pointer"
              :class="{ 'border border-red-600' : isTop }">
        <div class="px-2 py-2 border-b flex justify-between "
             :class="[{'bg-red-200' : isTop}, mission.is_fitting ? 'green-header' : 'bg-white']"
             @click="$emit('selected')">
            <div class="flex">
                <div class="sm:flex">
                    <div class="mt-1 font-bold">
                        <span class="text-sm bg-gray-200 rounded p-1 px-2">{{ $t('text.customerNumber') }}: {{ mission.customer_id }}</span>
                    </div>
                    <div class="mt-1 ml-1 flex text-sm">
                        {{ mission.location }}
                        <LocationSVG></LocationSVG>
                    </div>
                </div>
                <div>
                    <Verified class="inline" v-if="mission.mission_profile.verified_customer"></Verified>
                    <New v-else class="inline"></New>
                </div>
            </div>
            <div>
                <div @click.stop="toggleFavorite(mission)" v-if="mission.favorite">
                    <YellowHeartSVG/>
                </div>
                <div @click.stop="toggleFavorite(mission)" v-else>
                    <GrayHeartSVG/>
                </div>

            </div>
        </div>
        <div class="ml-2 mt-2 mb-2" @click="$emit('selected')">
            <MissionProfileCompensation
                    :compensation="mission.mission_profile.compensation"></MissionProfileCompensation>
            <MissionProfileSummary :mission-profile="mission.mission_profile" :isFitting="mission.is_fitting"></MissionProfileSummary>
        </div>
        <div class="px-2 py-2 border-t bg-gray-100 flex justify-between" @click="$emit('selected')">
            <div class="flex-col">
                <RightArrowSVG></RightArrowSVG>
                <Date :date="date"></Date>
                <span class="ml-2 text-sm rounded bg-green-200 px-2">{{ mission.active_applications }} {{ $tc('component.mission.active_applications', mission.active_applications)}}</span>
            </div>
            <div>

            </div>
        </div>
    </CardBase>
</template>

<script>
    import Date from "@/components/shared/Date";
    import RightArrowSVG from "@/components/shared/svgs/RightArrowSVG";
    import MissionProfileSummary from "@/components/missions/MissionProfileSummary";
    import MissionProfileCompensation from "@/components/missions/MissionProfileCompensation";
    import GrayHeartSVG from "@/components/shared/svgs/GrayHeartSVG";
    import LocationSVG from "@/components/shared/svgs/LocationSVG";
    import CardBase from "@/components/shared/CardBase";
    import Verified from "@/components/missions/labels/Verified";
    import New from "@/components/missions/labels/New";
    import YellowHeartSVG from "../shared/svgs/YellowHeartSVG";
    import MissionService from "../../services/mission.service";

    export default {
        name: "MissionItemSummary",
        components: {
            YellowHeartSVG,
            New,
            Verified,
            CardBase,
            LocationSVG, GrayHeartSVG, MissionProfileCompensation, MissionProfileSummary, RightArrowSVG, Date
        },
        props: ['selected', 'mission', 'isTop'],
        computed: {
            date() {
                return this.mission.arrival_date.split('-').reverse().join('.');
            }
        },
        methods: {
            async toggleFavorite(mission) {
                try {
                    await MissionService.toggleFavorite(mission.mission_id);
                    mission.favorite = !mission.favorite;
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }
</script>

<style scoped>
    .green-header {
        background-color: rgba(165, 223, 162, 0.5);
    }
</style>